module.exports = "/packs/review-completed-032a98b7e6a727b62b2862263bbba9df.png";